<template>
	<DialogFormDialog ref="dialog" :strings="strings" @reset="reset">
		<v-text-field
			v-model="values.name"
			:rules="nameRules"
			:label="strings.nameLabel"
			type="text"
		/>
	</DialogFormDialog>
</template>

<script>
import _ from "lodash";

import strings from "@/utils/strings";

const initData = () => ({
	strings: strings.live.scenes.addSceneDialog,

	values: { name: "" },
	nameRules: [v => !!_.trim(v).length || "Name is required", v => !v || !v.match(/\//) || "Invalid character!"],
});

export default {
	data: initData,

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	mounted() {
		this.pop = this.$refs.dialog.pop;
	},

	methods: {
		reset() {
			Object.assign(this, initData());
		},
	},
};
</script>
